<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                Success!<br /><br />
                Thank you for completing the A2P registration application. We will review your application and submit it to the Campaign Registry for review as soon as possible.<br>
                Before submitting your application, we may need your response. We will send an email to the email address you provided within the application.<br>
                Once your application has been reviewed and accepted by the Campaign Registry (usually between 2-3 business days after we have submitted it), you'll be able to begin sending messages.<br>
                <br /><br />
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import exampleSelectable from "../../components/A2p/ExampleSelectable";



export default {
    name: 'A2P-Review',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        exampleSelectable,
    },
    data() {
        return {

        }
    },
    computed: {
    },
    mounted() {

    },
    methods: {
    },
    watch: {
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

.label {
    @apply font-bold text-gray-700;
}

.value {
    @apply font-light text-gray-600;
}

</style>
